import React from 'react';
import { Box, DialogTitle, Theme, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useI18n } from '../../lib/hook/useI18n';
import PrivacyPolicyLink from './PrivacyPolicyLink';
import ThemableButton from '../../theme/components/Button/ThemableButton';

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    backgroundColor: theme.palette.grey[100],
  },
}));

interface Props {
  isConsentDeclinedSuppression?: boolean;
  onAccept?: () => void;
  onReject?: () => void;
  privacyPolicyName?: string;
}

const UnifiedConsentContent: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = useStyles();
  const { i18nClasses, t, tc } = useI18n();

  const {
    isConsentDeclinedSuppression = false,
    onAccept,
    onReject,
    privacyPolicyName,
  } = props;

  const renderAcceptButton = () => {
    if (isConsentDeclinedSuppression) {
      return (
        <ThemableButton onClick={onAccept}>
          {t('consent.body.newer_consent.accept')}
        </ThemableButton>
      );
    }

    return (
      <ThemableButton onClick={onAccept} variant="contained">
        {t('consent.body.newer_consent.continue')}
      </ThemableButton>
    );
  };

  return (
    <>
      <Box
        px={4}
        py={3}
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap={3}
      >
        <DialogTitle sx={{ p: 0, m: 0 }}>{t('consent.title')}</DialogTitle>
      </Box>

      <Box
        px={4}
        pb={3}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="flex-start"
        gap={2}
      >
        <Typography
          className={i18nClasses.root}
          color="textSecondary"
          variant="body2"
        >
          {t('consent.body.newer_consent.description_1')}
          <br />
          <br />
          {isConsentDeclinedSuppression
            ? t('consent.body.newer_consent.description_2_suppression', {
                accept: t('consent.body.newer_consent.accept'),
              })
            : t('consent.body.newer_consent.description_2', {
                continue: t('consent.body.newer_consent.continue'),
              })}{' '}
          {tc(
            'consent.body.newer_consent.terms',
            {},
            {
              0: <PrivacyPolicyLink privacyPolicyName={privacyPolicyName} />,
            }
          )}
        </Typography>
      </Box>
      <Box
        px={4}
        py={2}
        height={64}
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        gap={2}
        className={classes.footer}
      >
        {isConsentDeclinedSuppression && (
          <ThemableButton onClick={onReject}>
            {t('consent.body.newer_consent.reject')}
          </ThemableButton>
        )}
        {renderAcceptButton()}
      </Box>
    </>
  );
};

export default UnifiedConsentContent;
